// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"3ac7b46d","239":"a7c8e55d","455":"328a9b60","557":"9f67f2e6","727":"5d15b054"}[chunkId] + ".chunk.js";
};